import classNames from 'classnames'
import { useState } from 'react'
import dynamic from 'next/dynamic'
import { StencilCDNImage } from '@/components/Common/StencilImage'
import Info from '@/assets/common/info.inline.svg'

const Modal = dynamic(() => import('@/stories/components/Common/Modal'), {
  ssr: false,
})

const Text = ({ data }) => {
  const [showModal, setShowModal] = useState<boolean>(false)
  return (
    <div className={classNames({ 'flex items-center': data.image_url })}>
      {data.image_url && (
        <div
          className="mr-2 flex"
          style={{
            ...data.image?.style,
            minHeight: data.image?.height ?? '20',
            minWidth: data.image?.width ?? '20',
          }}
        >
          <StencilCDNImage
            src={data.image_url}
            alt={data.title ?? 'icon'}
            width={data.image?.width ?? '20'}
            height={data.image?.height ?? '20'}
            className={data.image?.className}
          />
        </div>
      )}

      {data?.bottomsheetInfo ? (
        <div className="flex w-full items-center justify-between">
          <div
            className={data.className}
            style={{ color: data.textColor, fontWeight: data.style }}
          >
            {data.title}
          </div>

          <span
            className="ml-1 h-4 w-4 cursor-pointer"
            onClick={() => setShowModal(true)}
          >
            <Info />
          </span>

          <Modal
            onClose={() => setShowModal(false)}
            showModal={showModal}
            bodyClassName="max-w-lg"
          >
            <div className="max-h-96 overflow-y-scroll">
              <div
                dangerouslySetInnerHTML={{
                  __html: data?.bottomsheetInfo,
                }}
              />
            </div>
          </Modal>
        </div>
      ) : (
        <div
          className={classNames(data.className, {
            'font-medium': data.style === 'bold',
          })}
          style={{
            color: data.textColor,
          }}
        >
          <div className="flex flex-col">
            {data.title}
            {data.subtitle && (
              <p className="text-brand-grey-base text-[11px]">
                {data.subtitle}
              </p>
            )}
          </div>
        </div>
      )}
    </div>
  )
}

export default Text
